/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';

import {
    Box,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useUIDSeed } from 'react-uid';
import { object } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import OfferDesignContainer from './OfferDesignContainer';
import OfferHeader from './Partials/OfferHeader';
import { getOfferInboxData } from '../../../../../../state/ducks/App/App-Selectors';
import { setOfferInboxDrawerOpen } from '../../../../../../state/ducks/App/App-Actions';

const useStyles = makeStyles((theme) => ({
    drawerPaper: {
        padding: 0,
        backgroundColor: '#fff',
    },
    drawerBackdrop: {
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
    },
    drawerContent: {
        position: 'relative',
        padding: '0 24px 24px 24px',
        [theme.breakpoints.down('sm')]: {
            padding: '0 16px 16px',
            height: '100%',
            overflowY: 'auto',
        },
    },
    container: {
        width: 366,
        maxWidth: 'calc(100vw - 48px)',
        [theme.breakpoints.down('sm')]: {
            width: '100%',
            maxWidth: 'calc(100vw - 32px)',
        },
    },
    closeBtn: {
        position: 'fixed',
        right: '24px',
        top: '20px',
        width: '24px',
        zIndex: 3,
        cursor: 'pointer',
        backgroundColor: '#fff',
    },
}));

const PersonalizedOfferInbox = ({ data }) => {
    const dispatch = useDispatch();
    const seed = useUIDSeed();
    const [groupedOffers, setGroupedOffers] = React.useState([]);

    const bannerData = data.content || {};

    const classes = useStyles();

    const handleCloseDrawer = () => {
        dispatch(setOfferInboxDrawerOpen(false));
    };

    const groupOffersWithOrder = () => {
        const offers = data?.content?.offers
            ?.map((offer) => {
                if (offer.type === 'offer-gateway') {
                    // Match with availableOffers by name
                    return data?.availableOffers?.find(
                        (item) => item.name === offer.title
                    );
                }
                // Otherwise use the offer directly
                return offer;
            })
            .filter(Boolean);

        let currentGroup = null;
        const grouped = offers.reduce((acc, offer) => {
            const headingObj = offer?.heading && offer?.heading.copy ? offer?.heading : null;

            const headingChanged = headingObj
                && (!currentGroup?.heading
                    || headingObj.copy !== currentGroup.heading.copy);

            if (!currentGroup || currentGroup.type !== offer?.type || headingChanged) {
                // start a new group
                currentGroup = {
                    type: offer?.type,
                    heading: headingObj,
                    offers: [offer],
                };
                acc.push(currentGroup);
            } else {
                // continue same group
                currentGroup.offers.push(offer);
            }
            return acc;
        }, []);

        return grouped;
    };

    React.useEffect(() => {
        const groupOffers = groupOffersWithOrder();
        setGroupedOffers(groupOffers);
    }, [data]);

    return (
        <Box className={classes.drawerContent}>
            <div
                className={classes.closeBtn}
                onClick={handleCloseDrawer}
                onKeyDown={handleCloseDrawer}
                role="button"
                tabIndex={0}
            >
                <img src={bannerData?.close_button?.icon?.url} alt="close" />
            </div>

            {groupedOffers.map((group, index) => (
                <div className={classes.container} key={seed(group)}>
                    <OfferHeader
                        offer={group.offers[0]}
                        firstItem={index === 0}
                    />
                    {
                        group?.offers?.map((offer, offerIndex) => (
                            <OfferDesignContainer
                                key={seed(offer)}
                                offer={offer}
                                data={bannerData}
                                notFirst={offerIndex !== 0}
                            />
                        ))
                    }
                </div>
            ))}
        </Box>

    );
};

PersonalizedOfferInbox.propTypes = {
    data: object,
};
PersonalizedOfferInbox.defaultProps = {
    data: {},
};

export default PersonalizedOfferInbox;
